import api from "@/helpers/api";

const API_BASE = `/api/custom-token`;

export default {
    namespaced: true,
    state: {
        status: '',
        tokens: [],
        currentToken: null,
        eligibleUsers: [],
        errMessage: '',
        meta: {
            limit: 10,
            page: 1,
            total: 1
        },
        filter: {},
        search: {}
    },
    mutations: {
        request(state) {
            state.status = 'loading'
        },
        success(state) {
            state.status = 'success'
        },
        error(state, { message }) {
            state.status = 'error'
            state.errMessage = message
        },
        set_tokens(state, { tokens, meta }) {
            state.tokens = [...tokens]
            if (meta) {
                state.meta = meta
            }
        },
        set_current(state, { token }) {
            state.currentToken = token
        },
        set_eligible_users(state, { users }) {
            state.eligibleUsers = [...users]
        },
        switch_page(state, { meta }) {
            state.meta = { ...meta }
        },
        set_search(state, { search }) {
            state.search = { ...search }
        },
        clear_search(state) {
            state.search = {}
        },
        reset_meta(state) {
            state.meta = {
                limit: 10,
                page: 1,
                total: 1,
            }
        }
    },
    actions: {
        // GET /api/custom-token — List all custom tokens
        read({ commit, state }) {
            commit('request');
            const { meta, search } = state;

            return new Promise((resolve, reject) => {
                api.request('get', API_BASE, { meta, search })
                    .then((result) => {
                        const responseData = result.data.data || {};
                        const tokens = responseData.tokens || [];
                        const meta = responseData.meta || {
                            page: state.meta.page,
                            limit: state.meta.limit,
                            total: tokens.length
                        }

                        commit('set_tokens', { tokens, meta });
                        commit('success');
                        return resolve(result);
                    }).catch((err) => {
                        commit('error', { message: err });
                        return reject(err);
                    });
            });
        },

        // GET /api/custom-token/{id} — Get token detail
        read_single({ commit }, id) {
            commit('request');

            return new Promise((resolve, reject) => {
                api.request('get', `${API_BASE}/${id}`)
                    .then((result) => {
                        commit('set_current', { token: result.data.data });
                        commit('success');
                        return resolve(result.data.data);
                    }).catch((err) => {
                        commit('error', { message: err });
                        return reject(err);
                    });
            });
        },

        // POST /api/custom-token — Create custom token
        create({ commit }, { data }) {
            commit('request');

            return new Promise((resolve, reject) => {
                api.request('post', API_BASE, {}, data)
                    .then((request) => {
                        commit('success');
                        return resolve(request);
                    }).catch((err) => {
                        commit('error', { message: err });
                        return reject(err);
                    });
            });
        },

        // DELETE /api/custom-token/{id} — Revoke token
        revoke({ commit, dispatch }, id) {
            commit('request');

            return new Promise((resolve, reject) => {
                api.request('delete', `${API_BASE}/${id}`)
                    .then((response) => {
                        dispatch('read'); // Reload list
                        commit('success');
                        return resolve(response.data);
                    }).catch((err) => {
                        commit('error', { message: err });
                        return reject(err);
                    });
            });
        },

        // GET /api/custom-token/eligible-users — Get eligible users for custom token
        getEligibleUsers({ commit }) {
            commit('request');

            return new Promise((resolve, reject) => {
                api.request('get', `${API_BASE}/eligible-users`)
                    .then((result) => {
                        commit('set_eligible_users', { users: result.data.data || [] });
                        commit('success');
                        return resolve(result);
                    }).catch((err) => {
                        commit('error', { message: err });
                        return reject(err);
                    });
            });
        }
    },
    getters: {
        tokens: (state) => state.tokens,
        currentToken: (state) => state.currentToken,
        eligibleUsers: (state) => state.eligibleUsers,
        status: (state) => state.status,
        errMessage: (state) => state.errMessage
    }
}
